<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import Icon from "@components/common/Icon.svelte";
	import Link from "@components/common/Link.svelte";
	import { ButtonVariant } from "@components/common/getButtonClass.js";
	import type { ComponentProps } from "svelte";
	import arrowNext from "@core/assets/icons/arrow-next.svg?raw";
	import { getConnectWithFastestPath } from "@core/schema/paths/getConnectWithFastestPath.js";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import { Background } from "./Background.js";
	import ContactCard from "./ContactCard.svelte";
	import Section from "./Section.svelte";

	const {
		contacts = [],
		headline: headlineOverride,
		desc: descOverride,
		buttonLabel: buttonLabelOverride,
	}: {
		contacts?: ComponentProps<typeof ContactCard>["contact"][];
		headline?: string;
		desc?: string;
		buttonLabel?: string;
	} = $props();
	const { tenant } = getGlobalTemplateProps();

	// Web čte novinky z databáze bez validace, takže přepis může dorazit i jako prázdný řetězec.
	const headlineText = $derived(
		headlineOverride ? headlineOverride : "cg[[Zarezervujte si termín]] bezplatné a nezávazné online konzultace",
	);
	const buttonLabelText = $derived(buttonLabelOverride ? buttonLabelOverride : "Domluvit schůzku");
</script>

<Section background={Background.LightGradient} gridHeadline="container-8 xl:container-6" centered>
	{#snippet headline()}
		<Formatted text={headlineText} />
	{/snippet}
	{#snippet desc()}
		{#if !descOverride}
			<p class="text-md text-center font-medium max-w-2xl xl:max-w-4xl mx-auto mb-1 text-fstonyx">
				<Formatted text="Chcete s námi nezávazně probrat podrobnosti?" />
			</p>
		{/if}
		<p class={["text-fstonyx text-md text-center max-w-3xl mx-auto", contacts.length === 0 && "md:mb-8"]}>
			<Formatted
				text={descOverride
					? descOverride
					: "Zamluvte si v kalendáři níže čas a termín 30minutové online schůzky zdarma."}
			/>
		</p>
		{#if contacts.length > 0}
			<div class="pt-8 pb-8 md:pb-12">
				<div
					class={{
						"grid justify-items-center md:mx-auto lg:max-w-5xl gap-4 md:gap-12 lg:gap-12": true,
						"grid-cols-1 lg:grid-cols-2": contacts.length > 1,
					}}
				>
					{#each contacts as contact (contact)}
						<ContactCard isBigger isLight background={Background.White} {contact} />
					{/each}
				</div>
			</div>
		{/if}
		<Link
			variant={ButtonVariant.Phlox}
			class="mx-auto flex items-center justify-center"
			href={getConnectWithFastestPath(tenant)}
		>
			<span>{buttonLabelText}</span>
			<!-- TODO: Uncomment when reservation form is ready.
			<span class="inline-block md:hidden">Domluvit schůzku</span>
			<span class="hidden md:inline-block">Přejít na rezervační kalendář</span>
			-->
			<Icon icon={arrowNext} class="ml-2 text-fstgrey-900"></Icon>
		</Link>
	{/snippet}
</Section>
